import React, { useEffect, useState } from "react";
import NewBilling from '../components/NewBilling';
import { useParams, useLocation, NavLink, useNavigate } from "react-router-dom";
import { useTeam } from '../../../shared/context/teamContext';

const SETTINGS_SECTIONS = [
  { path: 'usage', label: 'Usage' },
  { path: 'members', label: 'Members' },
  { path: 'config', label: 'Config' },
  { path: 'billing', label: 'Billing' },
];

const Settings = ({ screenSize = {} }) => {
  const { team } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [seteam, setseTeam] = useState(localStorage.getItem("selectedTeam"));
  const { selectedTeam } = useTeam();

  useEffect(() => {
    setseTeam(localStorage.getItem("selectedTeam"));
  }, [team]);

  const basePath = `/${team}/settings`;

  // Default /settings to /settings/usage
  useEffect(() => {
    if (team && location.pathname === basePath) {
      navigate(`${basePath}/usage`, { replace: true });
    }
  }, [team, basePath, location.pathname, navigate]);

  // Notifications preferences are now user-level settings.
  useEffect(() => {
    if (team && location.pathname.endsWith('/settings/notifications')) {
      navigate(`/${team}/user-settings`, { replace: true });
    }
  }, [team, location.pathname, navigate]);

  return (
    <div className="flex min-h-screen bg-white">
      {/* Secondary nav bar - vertical */}
      <aside
        className="flex-shrink-0 w-52 border-r border-gray-200 bg-white"
        style={{ fontFamily: 'Raleway, sans-serif' }}
      >
        <div className="sticky top-0 py-4 flex flex-col h-full">
          <nav className="flex-1 px-1 space-y-0.5">
            {SETTINGS_SECTIONS.map(({ path, label }) => {
              const to = `${basePath}/${path}`;
              const isActive =
                location.pathname === to || location.pathname.endsWith(`/settings/${path}`);
              return (
                <NavLink
                  key={path}
                  to={to}
                  className={`sidebar-nav-item flex items-center gap-2 py-1.5 px-3 mx-1 rounded-lg cursor-pointer text-sm transition-colors ${
                    isActive ? 'text-[#0f172a] bg-gray-100 hover:bg-gray-100' : 'text-[#0f172a] hover:bg-gray-100'
                  }`}
                  style={{ fontFamily: 'Raleway, sans-serif' }}
                >
                  {label}
                </NavLink>
              );
            })}
          </nav>
        </div>
      </aside>

      {/* Main content */}
      <main className="flex-1 min-w-0 overflow-auto">
        <div className="mt-2">
          <NewBilling />
        </div>
      </main>
    </div>
  );
};

export default Settings;
